import {createStrokeSVG} from './TEMPLATE'

// tabler: unlink
export const ChainLinkBroken_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M17 22v-2',
    'M9 15l6 -6',
    'M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464',
    'M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463',
    'M20 17h2',
    'M2 7h2',
    'M7 2v2',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: link
export const ChainLink_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M9 15l6 -6',
    'M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464',
    'M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
